import {t} from 'i18next';
import ArrBanner from '../../../../common/arr-banner/ArrBanner';
import {ReactComponent as AlertIcon} from '../../../../../assets/images/alert-icon.svg';
import './DraftProtocolChangedBanner.scss';

export type DraftProtocolChangedBannerContext = 'savedDraft' | 'submittedJob';

type DraftProtocolChangedBannerProps = {
  context: DraftProtocolChangedBannerContext;
  isVisible?: boolean;
};

const BANNER_COPY_KEY: Record<DraftProtocolChangedBannerContext, string> = {
  savedDraft: 'ai.review.newJobDetail.draftProtocolChangedBanner',
  submittedJob: 'ai.review.jobDetailsTab.draftProtocolChangedBanner',
};

const DraftProtocolChangedBanner = ({
  context,
  isVisible = false,
}: DraftProtocolChangedBannerProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <ArrBanner
      type="contextual"
      variant="warning"
      startIcon={<AlertIcon />}
      bannerContent={t(BANNER_COPY_KEY[context])}
      className="draft-protocol-changed-banner"
      dataTestId="draft-protocol-changed-banner"
    />
  );
};

export default DraftProtocolChangedBanner;
